const observationsRoutes: any = {
    path: 'observations',
    name: 'observations',
    meta: { title: 'project_menu.observation' },
    component: () => import('@/views/Project/Observation/views/Index.vue'),
    redirect: { name: 'all-observations' },

    children: [
        {
            name: 'all-observations',
            path: '',
            meta: { title: 'project_menu.observation' },
            components: {
                default: () => import('@/views/Project/Observation/views/Observations.vue'),
            },
        },
        {
            name: 'observation',
            path: 'observation/:observationId',
            meta: { title: 'project_menu.observation' },
            components: {
                default: () => import('@/views/Project/Observation/views/Observations.vue'),
                dialog: () => import('@/views/Project/Observation/views/Observation.vue'),
            },
        },
        {
            name: 'add-observation',
            path: 'add-observation',
            meta: { title: 'project_menu.observation' },
            components: {
                default: () => import('@/views/Project/Observation/views/Observations.vue'),
                dialog: () => import('@/views/Project/Observation/views/Observation.vue'),
            },
        },
    ],
}

export default observationsRoutes
